import React, { lazy, Suspense } from 'react';
import { RecoilRoot } from 'recoil';
import { Routes, Route } from 'react-router-dom';

import { FuegoProvider } from '@nandorojo/swr-firestore';
import { fuego } from '@store/firebase/index';
import ChunkErrorBoundary from '@components/library/ErrorBoundary/ChunkErrorBoundary';
import '@components/dataEntry/Input/DateInput/day-picker.css';
import GlobalStyle from '@styles/GlobalStyle';

const Main =
  process.env.NODE_ENV === 'production'
    ? lazy(() => import('./Main'))
    : require('./Main').default;

const EmbedCalendarPage = lazy(
  () => import('@pages/Embed/EmbedCalendarPage'),
);
const InitPage = lazy(() => import('@pages/Dev/InitPage'));

const App = () => {
  return (
    <ChunkErrorBoundary>
      <FuegoProvider fuego={fuego}>
        <GlobalStyle />
        <RecoilRoot>
          <Routes>
            <Route
              path="/embed/calendar/:boardKey"
              element={
                <Suspense fallback={null}>
                  <EmbedCalendarPage />
                </Suspense>
              }
            />
            <Route
              path="/__init"
              element={
                <Suspense fallback={null}>
                  <InitPage />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={null}>
                  <Main />
                </Suspense>
              }
            />
          </Routes>
        </RecoilRoot>
      </FuegoProvider>
    </ChunkErrorBoundary>
  );
};

export default App;
